import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Field, reduxForm, initialize } from 'redux-form';
import LoadingOverlay from '../components/LoadingOverlay';
import ReactGA from 'react-ga';
import { userActions } from '../actions/userActions';
import * as homeActions from '../actions/homeActions';
import ValidateField from '../components/ValidateField';
import PhoneInputField from '../components/PhoneInputField';
import { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

const validate = (values) => {
    const errors = {};

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    let passErrors = [];
    if (values.password && (values.password.length < 8 || values.password.length > 20)) {
        passErrors.push("be between 8 and 20 characters");
    }
    if (values.password && !/[a-z]/.test(values.password)) {
        passErrors.push("contain a lowercase letter");
    }
    if (values.password && !/[A-Z]/.test(values.password)) {
        passErrors.push("contain an UPPERCASE letter");
    }
    if (values.password && !/\d/.test(values.password)) {
        passErrors.push("contain a number");
    }
    if (passErrors.length > 0) {
        errors.password = `Password must: ${passErrors.join(", ")}`;
    }

    if (!values.firstName) {
        errors.firstName = 'Required';
    }
    if (!values.lastName) {
        errors.lastName = 'Required';
    }
    if (!values.email) {
        errors.email = 'Required';
    } else if (!validateEmail(values.email)) {
        errors.email = 'Invalid email';
    }

    console.log('- - - - - - - - - - - - - ');
    console.log('values.phone, ', values.phone);
    console.log('isValidPhoneNumber, ', isValidPhoneNumber(values.phone));
    // Phone validation
    if (!values.phone) {
        errors.phone = 'Required';
        console.log('if');
    } else if (!isValidPhoneNumber(values.phone)) {
        console.log('   else if');
        errors.phone = 'Invalid phone number';
    }

    console.log('errors, ', errors);
    
    return errors;
};

const AccountDetailsForm = (props) => {
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [cookiesAccepted, setCookiesAccepted] = useState(false);

    const togglePopover = () => {
        setPopoverOpen(!popoverOpen);
    };

    const handleInputChange = (evt) => {
        const target = {
            name: evt.target.name, 
            value: (evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value)
        };
        props.homeActions.updateInputValue(target);
    };

    useEffect(() => {
        const handleCookieAccept = () => setCookiesAccepted(true);
        window.addEventListener('CookiebotOnAccept', handleCookieAccept);
        
        return () => {
            window.removeEventListener('CookiebotOnAccept', handleCookieAccept);
        };
    }, []);

    const updatePhone = (value) => {
        let phone = '';
        for (let i = 0; i < Object.keys(value).length; i++) {
            phone += value[i] === undefined ? '' : value[i];
        }

        let num = value === undefined ? '' : value;

        if (num && isValidPhoneNumber(phone)) {
            props.homeActions.updateInputValue({ name: 'phone', value: phone });
        } else {
            props.homeActions.updateInputValue({ name: 'phone', value: '' });
        }
    };


    const { 
        handleLogin, 
        isLoading,
        loggedIn,
        firstName,
        lastName,
        email,
        tcAccepted
    } = props;

    return (
        <div className="row">
            <LoadingOverlay loading={isLoading} spinnerStyle={{ top: "20%" }}>
                <form name="accountDetailsForm" onSubmit={props.handleSubmit}>
                    <div className="account-card b-rad">
                        <div className="row header">
                            <div className="col-12 col-md-12">
                                <label className="card-title">Your Account</label>
                            </div>
                            <hr className=""/>
                            {!loggedIn && (
                                <div className="w-100">
                                    <div className="row mt-3 mb-n2 ">
                                        <div className="col-12 text-center">
                                            <p>Sign in and pay through your Easytrip account</p>
                                        </div>
                                    </div>
                                    <div className="col-12 text-center mb-3">
                                        <div>
                                            <button type="button" className="btn btn-easytrip btn-sm" onClick={handleLogin}>
                                                <svg className="easyTripOrbit" width="19px" height="22px" viewBox="0 0 19 22" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                                    <g id="Group" transform="translate(0.709717, 0.077917)">
                                                        <g className="easyTripOrbit_1">
                                                        </g>
                                                    </g>
                                                </svg>
                                                <span className="btn-easytrip__cta">Sign in with Easytrip</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <hr className="hr-or mt-4 mb-4 "/>
                                    </div>
                                </div>
                            )}
                        </div>
                        {!loggedIn && (
                            <div className="row">
                                <div className="col-12 text-center">
                                    <p>Create an account</p>
                                </div>
                                <div className="col-sm-6 my-2">
                                    <label className="card-title" htmlFor="firstName">First Name</label>
                                    <Field name="firstName" autocomplete="given-name" component={ValidateField} type="text" onChange={handleInputChange} />
                                </div>
                                <div className="col-sm-6 my-2">
                                    <label className="card-title" htmlFor="lastName ">Last Name</label>
                                    <Field name="lastName" component={ValidateField} type="text" onChange={handleInputChange} />
                                </div>
                                <div className="col-sm-6 my-2">
                                    <label className="card-title" htmlFor="email">
                                        Email
                                    </label>
                                    <Field name="email" component={ValidateField} type="email" onChange={handleInputChange} />
                                </div>
                                <div className="col-sm-6 my-2">
                                    <label className="card-title" htmlFor="password">
                                        Password
                                    </label>
                                    <Field name="password" 
                                        component={ValidateField} 
                                        type="password" 
                                        onChange={handleInputChange} />
                                </div>

                            </div>
                        )}

                        <div className="row">
                            <div className="col-md-6 my-2">
                                <label className="card-title" htmlFor="phone">Mobile</label>
                                <Field 
                                    name="phone" 
                                    component={PhoneInputField} 
                                    type="tel" 
                                    defaultCountry="IE"
                                    onChange={updatePhone} />
                            </div>
                        </div>

                        {loggedIn && (
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="account-card account-card__easyTrip">
                                        <div className="card-body">
                                            <div className="card-title">{firstName}{' '}{lastName}</div>
                                            <div className="card-text">{email}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {!loggedIn && (
                            <div className="row mt-3">
                                <div className="col-md-12">
                                    <div className="input_out input_out_inputButton">
                                        <input className="inp-cbx" 
                                            id="tcAccepted" 
                                            type="checkbox" 
                                            name="tcAccepted"
                                            tabIndex={0}
                                            onChange={handleInputChange}
                                            checked={tcAccepted}
                                            value={tcAccepted}
                                        />
                                        <label className="cbx m-0" htmlFor="tcAccepted">
                                            <span>
                                                <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                    <polyline points="1.5 6 4.5 9 10.5 1"/>
                                                </svg>
                                            </span>
                                            <span className="cbx-copy">I acknowledge and I agree to EasyTrip's <a href="https://www.easytrip.ie/terms-conditions/" target="blank">Terms &amp; Conditions</a>.</span>
                                        </label> 
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </form>
            </LoadingOverlay>
        </div>
    );
};

AccountDetailsForm.propTypes = {
    isLoading: PropTypes.bool,
    handleLogin: PropTypes.func.isRequired,
    loggedIn: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    homeActions: PropTypes.object,
    password: PropTypes.string,
    validate: PropTypes.func,
    tcAccepted: PropTypes.bool,
};

function mapStateToProps(state) {
    return {
        initialValues: state.accountDetails,
        enableReinitialize: true,
        keepDirtyOnReinitialize: true
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(userActions, dispatch),
        homeActions: bindActionCreators(homeActions, dispatch)
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(reduxForm({
    form: 'accountDetailsForm',
    validate,
    asyncBlurFields: [
        'password'
    ],
    onSubmitSuccess: (result, dispatch, props) => {
        dispatch(initialize(props.form, props.values));
        if (this.state.cookiesAccepted) {
            ReactGA.event({
                category: 'account detail',
                action: 'change account detail'
            });
        }
    }
})(AccountDetailsForm));


// WEBPACK FOOTER //
// ./src/forms/AccountDetailsForm.jsx